"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const store_1 = require("@/state/store");
const ValidationText_vue_1 = __importDefault(require("@SharedVueComponents/SharedForm/ValidationText.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'GlobalError',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(store_1.store).globalErrorMessages.length)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(store_1.store).globalErrorMessages, (error, i) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ValidationText_vue_1.default, {
                            key: error + i,
                            "error-message": error,
                            "no-indent": ""
                        }, null, 8, ["error-message"]));
                    }), 128))
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
